import { IDropdownSettings } from 'ng-multiselect-dropdown';

export class MultiSelectConfigHelper {
  public static getSettings = (
    idField= 'item_id',
    textField= 'item_text',
    singleSelection= false,
    selectAllText= 'Select All',
    unSelectAllText= 'UnSelect All',
    itemsShowLimit= 3,
    allowSearchFilter= true
  ): IDropdownSettings => {
    return {
      singleSelection: singleSelection,
      idField: idField,
      textField: textField,
      selectAllText: selectAllText,
      unSelectAllText: unSelectAllText,
      itemsShowLimit: itemsShowLimit,
      allowSearchFilter: allowSearchFilter
    };
  };
}
